import styled from 'styled-components'
import { PaddingType } from 'common/types/styleTypes'
import { mobilePaddingsCss, paddingsCss } from 'common/utils/styleUtilsNew'

type BlogPostListingUiNewProps = {
  padding: PaddingType
  mobilePadding?: PaddingType
}
const BlogPostListingUiNew = styled.div<BlogPostListingUiNewProps>`
  ${paddingsCss};
  ${p => p.theme.isEditorMobileMode && mobilePaddingsCss}
  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
  }
`

export default BlogPostListingUiNew
